export default __webpack_public_path__ + "static/media/delete.da9f014a.svg";